import { Component, OnDestroy, OnInit, ViewChild, Inject, afterNextRender } from '@angular/core';
import { MatTable, MatTableDataSource, MatTableModule } from "@angular/material/table";
import { Router } from "@angular/router";
import { ViewportScroller } from "@angular/common";
import { OrganizationsService } from '../../services/organizations/organizations.service.js';
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { Subscription } from "rxjs";
import { OrganizationsControls } from "./organizations-controls/organizations-controls.component";
import { MatSortModule } from "@angular/material/sort";
import { OrganizationRow, DataUtil, SortEvent } from 'allai-admin-shared';
import { OrganizationsFilterService } from '../../services/organizations/organizations-filter.service.js';

/** The organization list page */
@Component({
	selector: 'app-organizations',
	imports: [
		MatTableModule,
		MatIconModule,
		MatButtonModule,
		OrganizationsControls,
		MatSortModule
	],
	templateUrl: './organizations.component.html',
	styleUrl: './organizations.component.scss'
})
export class OrganizationsComponent implements OnInit, OnDestroy {

	/** Columns in the table */
	readonly displayedColumns: (keyof OrganizationRow)[] = ['id', 'name','enabled','trial_account','days_from_appointment','time_zone'];

	/** Data source for the table */
	dataSource: MatTableDataSource<OrganizationRow>;

	/** Current search filter being applied */
	private _searchFilter: string;

	/** Table on the page showing the organization */
	@ViewChild(MatTable)
	private table: MatTable<OrganizationRow>;

	/** Subscription for new organizations being loaded from filters */
	private newOrganizationsSub: Subscription;

	@ViewChild(OrganizationsControls)
	private organizationControls: OrganizationsControls;

	constructor(private organizationService: OrganizationsService,
		private organizationFilterService: OrganizationsFilterService,
		private router: Router,
		@Inject(ViewportScroller) private viewportScroller: ViewportScroller) {
	}

	ngOnInit() {
		this.newOrganizationsSub = this.organizationService.onNewOrganizations.subscribe(() => {
			this.refresh();
		});

		this.organizationService.resolveOrganizations();

	}

	private refresh() {

		const organizationList = this.organizationService.organizationList;

		this.organizationControls.setTotal(this.organizationService.total);

		const rows: OrganizationRow[] = organizationList;

		//make sure to re-render table
		this.dataSource = new MatTableDataSource<OrganizationRow>(rows);
		this.table?.renderRows();
	}

	ngOnDestroy() {
		this.newOrganizationsSub?.unsubscribe();
	}

	/** Open an organization that was clicked on */
	goto(row: OrganizationRow) {
		let url = this.router.serializeUrl(this.router.createUrlTree(['/', 'organizations', row.id]));
		window.open(url, `_organization_${row.id}`);
	}

	formatDate(date: string): string {
		return new Date(date).toLocaleString();
	}

	sortData(sortEvent: SortEvent) {
		this.organizationFilterService.sortOrder = sortEvent
	}
}
